<script>
  import { footer } from '../../stores/footer'
  import Nrk from '../Nrk.svelte'
  import Interaksjon from './interaksjon.svelte'
</script>

<style>
  .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 590px;
    margin: 0 auto;
    text-align: center;
    color: var(--primary);

    padding: 30px 0 60px;
  }

  .kreditering {
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 6px;
  }

  .role {
    margin: 0;
    font-size: 18px;
  }

  .text {
    margin: 0 0 16px;
    font-size: 16px;
  }

  .redaktor {
    font-size: 14px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    grid-gap: 0 10px;
    gap: 0 10px;
    color: var(--primary);
    line-height: 1.43;
  }

  .small {
    color: var(--primary);
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    line-height: 1.43;
  }
</style>

<div class="footer">
  <Interaksjon interaksjon={$footer.publikumsinteraksjon} />
  <div class="kreditering">
    <Nrk space="footer" />
    {#each $footer.krediteringer as kred}
      <h3 class="role">{kred.rolle}</h3>
      <p class="text">
        {#each kred.medlemmer as medlem, i}
          <span>{medlem.navn}{kred.medlemmer.length > 2 && i < kred.medlemmer.length - 2 ? ', ' : i === kred.medlemmer.length - 2 ? ' og ' : ''}
          </span>
        {/each}
      </p>
    {/each}
    <p class="small">{$footer.opphavsrett}</p>
    <div class="redaktor">
      {#each $footer.redaktoransvar as redaktoransvar}
        <div>{redaktoransvar}</div>
      {/each}
    </div>
  </div>
</div>
